import ProductRepository from 'src/repository/ProductRepository';
import Helper from 'src/support/Helper';
import _, { isNumber, isObject } from 'underscore';
// import System from "../../../helper/system";
// import ProductRepository from "src/repository/ProductRepository";
// import BOMDetail from 'src/model/BOMDetail';

class ResponseMaker {
    data = [];
    data_to_send = {
        totalAlertList: 0,
        alertList: []
    };

    constructor(data) {
        this.data = data;
    }

    process = async () => {
        let value = [];

        // Handling blank data in case of PCN Tab EOL Filter 
        if(this.data === undefined || this.data === null) {
            this.data_to_send.totalAlertList = 0;
            this.data_to_send.alertList = [];
        }
        if (this.data!==undefined && this.data!==null && this.data.total !== undefined) {
            this.data_to_send.totalAlertList = this.data.total
        }
        if (this.data!==undefined && this.data!==null && this.data.notificationResult !== undefined && this.data.notificationResult.length > 0) {
            this.data.notificationResult.map((v, i) => {
                let here_v = {}

                here_v.ERPPartNumber = v['sapNumber'] && v['sapNumber']

                if (v['customerPartNumber'] !== undefined) {
                    here_v.customerPartNumber = v['customerPartNumber']
                }
                if (v['manufacturerPartNumber'] !== undefined) {
                    here_v.manufacturerPartNumber = v['manufacturerPartNumber']
                }
                if (v['manufacturerName'] !== undefined) {
                    here_v.manufacturer = v['manufacturerName']
                }
                if (v['pcnDownload'] !== undefined) {
                    here_v.pcnDownload = v['pcnDownload']
                }
                if (v['pcnAffectedParts'] !== undefined) {
                    here_v.affectedParts = v['pcnAffectedParts']
                }
                if (v['issueDate'] !== undefined) {
                    here_v.issueDate = v['issueDate']
                    here_v.finalIssueDate = Helper.dateFormatFromString(v['issueDate'])
                }
                if (v['pcnType'] !== undefined) {
                    here_v.changeType = v['pcnType']
                }
                if (v['impact'] !== undefined) {
                    here_v.impact = v['impact']
                }
                if (v['impactType'] !== undefined) {
                    here_v.impactType = v['impactType']
                }
                if (v['lastTimeBuy'] !== undefined) {
                    here_v.lastBuyDate = v['lastTimeBuy'];
                    here_v.finalLastBuyDate = Helper.dateFormatFromString(v['lastTimeBuy'])
                }
                if (v['status'] !== undefined) {
                    here_v.status = v['status']
                }
                
                if (v['manufacturerName'] !== undefined) {
                    here_v.mFG = v['manufacturerName'];
                }
                if (v['manufacturerPartNumber'] !== undefined) {
                    here_v.mfgPartNumber = v['manufacturerPartNumber']
                }
                if (v['manufacturerPartNumber'] !== undefined) {
                    here_v.manufacturingPartNumber = v['manufacturerPartNumber']
                }
                if (v['pcnDescription'] !== undefined) {
                    here_v.partDescription = v['pcnDescription']
                }

                if (v['repPart'] !== undefined) {
                    here_v.replacementPart = v['repPart'];
                    here_v.replacement = v['repPart'];
                }

                here_v.status = ''; // EOL export development pending for this 
                here_v.pERBRDLTS = ''; // PCN export development pending for this 
                value[i] = here_v;
            })

            let alertList = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(value, false, false);
            this.data_to_send.alertList = alertList
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;